<script lang="ts">
  import { Card, Col } from "sveltestrap";
  import Business from "./Business.svelte";
  import FavoritesContact from "./FavoritesContact.svelte";
  import FollowUp from "./FollowUp.svelte";
  import Ideas from "./Ideas.svelte";
  import Important from "./Important.svelte";
  import OrganizationContact from "./OrganizationContact.svelte";
  import PersonalContactDetails from "./PersonalContactDetails.svelte";
  import Holidays from "./Holidays.svelte";
</script>
<Col xl="9" md="12" class="box-col-8 xl-70">
  <div class="email-right-aside bookmark-tabcontent contacts-tabs">
    <Card class="email-body radius-left">
      <div class="ps-0">
        <div class="tab-content">
          <PersonalContactDetails />
          <OrganizationContact />
          <FollowUp />
          <FavoritesContact />
          <Ideas />
          <Important />
          <Business />
          <Holidays />
        </div>
      </div>
    </Card>
  </div>
</Col>